import React, { Component } from 'react';
import './Layout.scss';

const Logo = () => <div className='logo'>
    <div className='logo-image'></div>
    <div className='logo-text'>
        <span>
            Talking
            Roots 
            Psychotherapy
        </span>
       
    </div>
</div>

const Layout = (props) => {
    return <div className='layout'>

        <div className='container-fluid g-0 banner'>
            <div className='row g-0'>
                <div className='logo-sm col-sm-4 col-md-4 col-lg-3'>  <Logo></Logo></div>
                <div className='col-sm-8 col-md-8 col-lg-9'> { props.left}</div>
              
            </div>
        </div>
       
        <div className='container g-0'>
            <div className='row g-0 mt-4'>      
                <div className='col-lg-9 mt-lg-5 pe-5'>
                    {props.children}
                </div>
                <div className='col-lg-3  mt-lg-5 p-2'>{props.right}</div>
            </div>
        </div>
       
       

    </div>
}

export { Layout }